export default "__VITE_ASSET__2e0b4494__"